import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "./CSS/Badminton.css";

function Shuttle() {
  return (
    <div className="badminton-shuttle" aria-hidden="true">
      <span className="shuttle-feather shuttle-feather-a" />
      <span className="shuttle-feather shuttle-feather-b" />
      <span className="shuttle-feather shuttle-feather-c" />
      <span className="shuttle-head" />
    </div>
  );
}

function Player({ side }) {
  return (
    <div className={`badminton-player ${side}`} aria-hidden="true">
      <div className="player-racket" />
      <div className="player-head" />
      <div className="player-body" />
      <div className="player-leg left" />
      <div className="player-leg right" />
    </div>
  );
}

export default function Badminton() {
  const [showSplash, setShowSplash] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [form, setForm] = useState({ username: "", password: "" });

  useEffect(() => {
    const timer = setTimeout(() => setShowSplash(false), 10000);
    return () => clearTimeout(timer);
  }, []);

  const canEnter = useMemo(() => {
    return form.username.trim().length > 0 && form.password.trim().length > 0;
  }, [form.username, form.password]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!canEnter) return;
    setLoggedIn(true);
    setShowLogin(false);
  };

  return (
    <main className="badminton-page">
      <div className="badminton-rally" aria-hidden="true">
        <div className="badminton-court" />
        <div className="badminton-net" />
        <Shuttle />
        <Player side="left" />
        <Player side="right" />
        <div className="badminton-glow badminton-glow-a" />
        <div className="badminton-glow badminton-glow-b" />
      </div>

      <section className={`badminton-splash ${showSplash ? "visible" : "hidden"}`}>
        <div className="badminton-splash-card">
          <p className="badminton-eyebrow">FuelFlow Special</p>
          <h1>WELCOME TRISHAAN</h1>
          <p className="badminton-splash-subtitle">
            A tiny badminton arena, full of motion, just for fun.
          </p>
          <button type="button" className="badminton-splash-button" onClick={() => setShowSplash(false)}>
            Enter Court
          </button>
        </div>
      </section>

      <section className={`badminton-shell ${showSplash ? "dimmed" : ""}`}>
        <header className="badminton-header">
          <div>
            <p className="badminton-kicker">Badminton</p>
            <h2>Playful demo page</h2>
            <p className="badminton-copy">
              <Link to="/badminton">/badminton</Link> is built to feel like a tiny court-side
              animation, not a form page.
            </p>
          </div>
          <div className="badminton-header-actions">
            <button type="button" className="badminton-login-pill" onClick={() => setShowLogin(true)}>
              {loggedIn ? "Play Again" : "Login"}
            </button>
            <div className="badminton-status">
              <span className={loggedIn ? "live" : ""}>{loggedIn ? "In rally" : "Waiting"}</span>
              <strong>{loggedIn ? "Court unlocked" : "Tap login"}</strong>
            </div>
          </div>
        </header>

        <div className="badminton-score-ribbon" aria-hidden="true">
          <div className="badminton-score-track">
            <span>Match mood: fast rallies</span>
            <span>Score 21 - 18</span>
            <span>Smash speed: super fast</span>
            <span>Energy: high</span>
            <span>Match mood: fast rallies</span>
            <span>Score 21 - 18</span>
            <span>Smash speed: super fast</span>
            <span>Energy: high</span>
          </div>
        </div>
      </section>

      {showLogin && (
        <div className="badminton-login-overlay" role="presentation">
          <div className="badminton-login-card" role="dialog" aria-modal="true" aria-labelledby="badminton-login-title">
            <button
              type="button"
              className="badminton-login-close"
              onClick={() => setShowLogin(false)}
              aria-label="Close login"
            >
              ×
            </button>

            <p className="badminton-eyebrow">Court Entry</p>
            <h3 id="badminton-login-title">Enter the rally</h3>
            <p className="badminton-login-copy">
              Type any name and any pass. This is just a fun pop-up gate.
            </p>

            <form onSubmit={handleSubmit} className="badminton-form">
              <label>
                <span>Player name</span>
                <input
                  type="text"
                  value={form.username}
                  onChange={(e) => setForm((prev) => ({ ...prev, username: e.target.value }))}
                  placeholder="Trishaan"
                />
              </label>

              <label>
                <span>Racket pass</span>
                <input
                  type="password"
                  value={form.password}
                  onChange={(e) => setForm((prev) => ({ ...prev, password: e.target.value }))}
                  placeholder="Any password"
                />
              </label>

              <button type="submit" className="badminton-primary" disabled={!canEnter}>
                {loggedIn ? "Back On Court" : "Enter Court"}
              </button>
            </form>
          </div>
        </div>
      )}
    </main>
  );
}
